export const POST_TYPE = {
  VIDEO: 'video',
  SHARE: 'share',
};

export default {};
